/**
 * user接口统一管理
 */
import {
  applyRole,
  delRole,
  editUserInfo,
  getBindPhoneCode,
  getEmployees,
  getForgetSmsReg,
  getLoginInfobyPhone,
  getLoginQrCode,
  getLoginQrCodeStatus,
  getLoginSms,
  getPersonLoginInfoByCode,
  getProtocolPrivacy,
  getProtocolUser,
  getRoleEntList,
  getRoleList,
  getUserInfo,
  joinEnt,
  login,
  postSmsReg,
  putUserPasswdForget,
  regEnt,
  registerPlatAdmin,
  setAdminRole,
  setDefaultLoginInfo,
  setEntCheck,
  smsLogin,
  wxBindPhone
} from '@/services/user'
import {getToken, setToken} from '@/utils/util'

export default {
  state: {
    phone: '',
    userName: '',
    userId: '',
    avatarImgPath: '',
    entName: '',
    entId: '',
    depart: '',
    access: '',
    position: '',
    token: getToken(),
    isBbsAdmin: 0,
    isEntAdmin: 0,
    isEntUser: 1,
    entCount: 1,
    hasGetInfo: false,
    loginAppInfo: ''
  },
  getters: {},
  mutations: {
    setEntCount (state, entCount) {
      state.entCount = entCount
    },
    setPhone (state, phone) {
      state.phone = phone
    },
    setAvatar (state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setUserName (state, name) {
      state.userName = name
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setDepart (state, depart) {
      state.depart = depart
    },
    setPosition (state, position) {
      state.position = position
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setAccess (state, access) {
      state.access = access
    },
    setEntName (state, entName) {
      state.entName = entName
    },
    setEntId (state, entId) {
      state.entId = entId
    },
    setEntAdmin (state, isEntAdmin) {
      state.isEntAdmin = isEntAdmin
    },
    setEntUser (state, isEntUser) {
      state.isEntUser = isEntUser
    }
  },
  actions: {
    handleLogin ({commit}, {userName, password, entId}) {
      return new Promise((resolve, reject) => {
        try {
          login(userName, password, entId).then(res => {
            if (res.code === 0) {
              const data = res.data
              commit('setToken', data.token)
              resolve(data)
            } else {
              reject(res.msg)
            }
          }, error => {
            reject(error)
          })
        } catch (e) {
          reject(e)
        }
      })
    },

    setLoginToken ({commit}, token) {
      commit('setToken', token)
    },

    // 退出登录
    handleLogOut ({commit}) {
      commit('setToken', '')
      commit('setHasGetInfo', false)
    },
    // 获取用户相关信息
    getUserInfo ({state, commit}) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo(state.token).then(res => {
            const data = res.data
            let loginEntId = 0
            let loginEntName = ''
            if (data.currentEnt) {
              loginEntId = data.currentEnt.id || 0
              loginEntName = data.currentEnt.name || 0
            }
            commit('setEntName', loginEntName)
            commit('setEntId', loginEntId)

            commit('setAvatar', data.logo)

            commit('setPhone', data.phone)
            commit('setUserName', data.name)
            commit('setUserId', data.id)

            commit('setAccess', data.access)

            commit('setEntAdmin', data.isEntAdmin)
            commit('setEntUser', data.isEntUser)
            commit('setEntCount', data.entCount)

            commit('setHasGetInfo', true)

            resolve(data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    editUserInfo (store, params) {
      return editUserInfo(params)
    },
    registerPlatAdmin (store, params) {
      return registerPlatAdmin(params)
    },

    postSmsReg (store, phone) {
      return postSmsReg(phone)
    },

    regEnt (store, params) {
      return regEnt(params)
    },

    getRoleList (store, params) {
      return getRoleList(params)
    },
    applyRole (store, params) {
      return applyRole(params)
    },
    getForgetSmsReg (store, phone) {
      return getForgetSmsReg(phone)
    },
    putUserPasswdForget (store, params) {
      return putUserPasswdForget(params)
    },
    joinEnt (store, params) {
      return joinEnt(params)
    },
    setAdminRole (store, params) {
      return setAdminRole(params)
    },
    delRole (store, roleId) {
      return delRole(roleId)
    },
    getEmployees (store, params) {
      return getEmployees(params)
    },
    getLoginInfobyPhone (store, params) {
      return getLoginInfobyPhone(params)
    },
    setEntCheck (store, params) {
      return setEntCheck(params)
    },
    getProtocolUser (store) {
      return getProtocolUser()
    },
    getProtocolPrivacy (store) {
      return getProtocolPrivacy()
    },
    getLoginQrCode (store, params) {
      return getLoginQrCode(params)
    },
    getLoginQrCodeStatus (store, session) {
      return getLoginQrCodeStatus(session)
    },
    getLoginSms (store, params) {
      return getLoginSms(params)
    },
    smsLogin ({commit}, params) {
      return new Promise((resolve, reject) => {
        try {
          smsLogin(params).then(res => {
            if (res.code === 0) {
              const data = res.data
              commit('setToken', data.token)
              resolve(data)
            } else {
              reject(res.msg)
            }
          }, error => {
            reject(error)
          })
        } catch (e) {
          reject(e)
        }
      })
    },
    getPersonLoginInfoByCode ({commit}, params) {
      return getPersonLoginInfoByCode(params)
    },
    getBindPhoneCode (store, params) {
      return getBindPhoneCode(params)
    },
    wxBindPhone (store, params) {
      return wxBindPhone(params)
    },
    getRoleEntList (store, params) {
      return getRoleEntList(params)
    },
    setDefaultLoginInfo (store, params) {
      return setDefaultLoginInfo(params)
    },
  }
}
